// removed by extract-text-webpack-plugin
module.exports = {"welcomeMusic":"Music__welcomeMusic","welcomeMusicContent":"Music__welcomeMusicContent","logo":"Music__logo","mobileHeader":"Music__mobileHeader","excludeHeader":"Music__excludeHeader","growDotQello":"Music__growDotQello","growDotBlue":"Music__growDotBlue","growDotGolden":"Music__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Music/Music.scss
// module id = 1861
// module chunks = 0